export const buildWebAppUrl = ({
  baseUrl,
  path = '',
}: {
  baseUrl: string;
  path?: string;
}): string => {
  const normalizedBase = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
};

export const buildAppointmentUrl = ({
  baseUrl,
  tenantId,
  appointmentId,
}: {
  baseUrl: string;
  tenantId: string;
  appointmentId: string;
}): string => {
  return buildWebAppUrl({
    baseUrl,
    path: `/organizations/${tenantId}/appointments/${appointmentId}`,
  });
};

export const buildSummaryUrl = ({
  baseUrl,
  tenantId,
  appointmentId,
}: {
  baseUrl: string;
  tenantId: string;
  appointmentId: string;
}): string => {
  return `${buildAppointmentUrl({ baseUrl, tenantId, appointmentId })}?tab=summary`;
};

export const buildSettingsUrl = ({
  baseUrl,
  tenantId,
}: {
  baseUrl: string;
  tenantId: string;
}): string => {
  return buildWebAppUrl({
    baseUrl,
    path: `/organizations/${tenantId}/settings`,
  });
};

export const buildInsightsSettingsUrl = ({
  baseUrl,
  tenantId,
}: {
  baseUrl: string;
  tenantId: string;
}): string => {
  return buildWebAppUrl({
    baseUrl,
    path: `/organizations/${tenantId}/settings/insights`,
  });
};

/**
 * Best-effort extraction of `tenantId` and `appointmentId` from an app URL
 * pathname. Used to enrich telemetry from contexts (like an error fallback)
 * where the corresponding React providers aren't available.
 */
export const extractTenantAndAppointmentIdsFromPath = (
  pathname: string,
): { tenantId: string | undefined; appointmentId: string | undefined } => {
  const tenantMatch = pathname.match(/\/organizations\/([a-fA-F0-9-]+)/);
  const appointmentMatch = pathname.match(/\/appointments\/([a-fA-F0-9-]+)/);
  return {
    tenantId: tenantMatch?.[1],
    appointmentId: appointmentMatch?.[1],
  };
};
